import { FC } from 'react';
import { getSalesInfo, getSalesInfoLoader } from 'redux/reducers/dashboard/selectors';
import { useSelector } from 'react-redux';
import { nanoid } from '@reduxjs/toolkit';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { OrdersItem } from './OrdersItem';
// import salesInformation from '../api/salesInformation.json';

export const SalesInformation: FC = () => {
	const salesInformation = useSelector(getSalesInfo);
	const salesInformationIsLoading = useSelector(getSalesInfoLoader);

	return (
		<div>
			{!salesInformationIsLoading && !!salesInformation?.length && (
				<Card
					sx={{
						mb: 2,
						borderRadius: '12px',
						'& .MuiCardContent-root': { padding: '8px 16px 16px 16px!important' },
					}}
				>
					<CardContent>
						<Typography
							variant="h5"
							color="primary"
							sx={{
								fontSize: '1.2rem',
								fontWeight: 'bold',
							}}
						>
							Sales Handled by EAS
						</Typography>
						<p style={{ marginTop: 0 }}>
							<small style={{ color: '#016193c0' }}>
								Date range: the last 30 days | Compared to: Previous 30 days
							</small>
						</p>
						<Box
							sx={{
								display: { md: 'grid', xs: 'flex' },
								flexDirection: 'column',
								marginTop: '20px',
								gap: 2,
								gridTemplateColumns: {
									xs: 'repeat(auto-fit, minmax(360px, 1fr))',
									sm: 'repeat(auto-fill, minmax(400px, 1fr))',
								},
								gridTemplateRows: 'repeat(6, auto-fit)',
								gridGap: '1rem',
								gridAutoFlow: 'row dense',
							}}
						>
							{salesInformation?.map((item, index) => {
								if (
									Number(item?.orderAmount ?? 0) +
									Number(item?.orderAmountPercent ?? 0) +
									Number(item?.orderCount ?? 0) +
									Number(item?.orderCountPercent ?? 0)
								)
									return (
										<Box
											key={nanoid()}
											sx={{
												// /border: '1px solid #f7f7f7',
												borderRadius: '12px',
												padding: '10px',
												backgroundColor: '#bdd2df99', // '#0092de24',
												// maxWidth: '560px',
											}}
										>
											<Typography
												color="primary"
												sx={{
													fontSize: '1.6rem',
													fontWeight: 'bold',
													textAlign: 'center',
													mb: 1,
												}}
											>
												{item.name}
											</Typography>
											<div style={{ display: 'flex', flexDirection: 'row' }}>
												<OrdersItem
													text="Orders Count"
													amount={item.orderCount}
													percent={item.orderCountPercent}
												/>
												<OrdersItem
													text="Orders Amount"
													amount={
														// 	new Intl.NumberFormat('en-EN', {
														// 	style: 'currency',
														// 	currency: 'EUR',
														// }).format(
														item.orderAmount

														// )
													}
													percent={item.orderAmountPercent}
													isAmount
												/>
											</div>
										</Box>
									);
								return null;
							})}
						</Box>
					</CardContent>
				</Card>
			)}
		</div>
	);
};
